import styled from 'styled-components'

export const BreakFlexLine = styled.div`
  flex-basis: 100%;
  height: 0px;
`
